module.exports = __webpack_public_path__ + "img/zx_icon.d0e48fab.png";